import { AddBox } from "@mui/icons-material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { formatErrorMessage, toTitleCase } from "../../../common/utils";
import { fetchFormDropdowns } from "../../../services/formDropdownsApiService";
import { showToaster } from "../../../services/toastService";
import BreadcrumbsComponent from "../../common/BreadcrumbsComponent";
import FormDropdownsCreateDialog from "./FormDropdownsCreateDialog";
import FormDropdownsList from "./FormDropdownsList";

const FormDropdowns: React.FC = () => {
  const [formDropdowns, setFormDropdowns] = useState({} as any);
  const [selectedType, setSelectedType] = useState("line-item-unit");
  const [showModal, setShowModal] = useState(false);

  const { data, isError, error } = useQuery({
    queryKey: ["form-dropdowns"],
    queryFn: () => fetchFormDropdowns(),
    staleTime: 0,
  });

  useEffect(() => {
    if (data) {
      processData(data);
    }
    if (isError) {
      handleOnError(error);
    }
  }, [data, error]);

  function handleOnError(error: any): void {
    console.log("error on fetchFormDropdowns ", error);
    showToaster(
      "Error fetching formDropdowns " + formatErrorMessage(error.message),
      "error"
    );
  }

  function processData(resp: any): void {
    setFormDropdowns(resp.data || []);
  }

  function handleSelectChange(event: any): void {
    setSelectedType(event.target.value);
  }

  function handleCreate(event: any): void {
    setShowModal(true);
  }

  function handleOnSaved(formDropdown: any): void {
    console.log("formDropdown saved ", formDropdown);
    const newFormDropdowns = { ...formDropdowns };
    newFormDropdowns[selectedType].push(formDropdown);
    setFormDropdowns(newFormDropdowns);
  }

  function handleOnListUpdated(list: any[]): void {
    const newFormDropdowns = { ...formDropdowns };
    newFormDropdowns[selectedType] = list;
    setFormDropdowns(newFormDropdowns);
  }

  return (
    <>
      <ToastContainer />
      <FormDropdownsCreateDialog
        formDropdown={null}
        type={selectedType}
        show={showModal}
        onHide={() => setShowModal(false)}
        onSaved={handleOnSaved}
      />
      <div className="container">
        <BreadcrumbsComponent
          links={[
            { to: "/settings", label: "Settings" },
            { to: "/settings/form-controls", label: "Form Controls" },
          ]}
          leaf="Form Dropdowns"
        />
        <div className="page-title">Form Dropdowns</div>
        <div className="row px-3 mt-3">
          <div className="col-auto mt-1">Type:</div>
          <div className="col-auto">
            <select className="form-control" onChange={handleSelectChange}>
              {Object.keys(formDropdowns).map((key: string) => (
                <option key={key} value={key}>
                  {toTitleCase(key)}
                </option>
              ))}
            </select>
          </div>
          <div className="col d-flex justify-content-end">
            <button className="btn btn-primary mr-5" onClick={handleCreate}>
              <AddBox className="mr-2" />
              {"Create " + toTitleCase(selectedType)}
            </button>
          </div>
        </div>

        <div className="row">
          <FormDropdownsList
            formDropdown={formDropdowns[selectedType]}
            onListUpdated={handleOnListUpdated}
          />
        </div>
      </div>
    </>
  );
};

export default FormDropdowns;
